// Runtime config injected at deploy time as config.js (window.SENTRIA_CONFIG).
// See WebsiteHosting construct. The API is same-origin, so apiBasePath is a
// relative path ("/reports") served by the CloudFront /reports* behavior.
export interface SentriaConfig {
  readonly apiBasePath: string;
  readonly preferencesBasePath: string;
  readonly capabilitiesBasePath: string;
  readonly region: string;
  readonly cognitoDomain: string;
  readonly userPoolClientId: string;
  readonly redirectUri: string;
  readonly logoutUri: string;
  readonly oauthScopes: string[];
  readonly identityProvider: string;
  readonly scopes: string[];
}

declare global {
  interface Window {
    SENTRIA_CONFIG?: SentriaConfig;
  }
}

export function getConfig(): SentriaConfig {
  const config = window.SENTRIA_CONFIG;
  if (!config) {
    throw new Error('SENTRIA runtime config missing; config.js failed to load.');
  }
  return config;
}
